export default __webpack_public_path__ + "static/beauty-look-winter-51102972d3057b56e4c8510cf9f43bfe.jpg";